import styled from 'styled-components'
import { Colors } from '../../../../../styles'

export const GridWrapper = styled.div`
  width: 100%;
  overflow: auto;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background: ${Colors.white};
  height: ${(props) => props.height}px;
`

export const StyledTable = styled.table`
  width: 100%;
  font-size: 14px;
  min-width: 600px;
  border-spacing: 0;
  table-layout: fixed;
  border-collapse: separate;
`

export const StyledThead = styled.thead`
  top: 0;
  z-index: 2;
  position: sticky;
`

export const StyledTh = styled.th`
  top: 0;
  z-index: 2;
  position: sticky;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 8px;
  /* white-space: nowrap; */
  color: ${Colors.white};
  background: ${Colors.softBlue};
  border-inline: 1px solid ${Colors.white};
  z-index: ${(props) => (props.left ? 20 : 0)};
  left: ${(props) => (props.left ? props.left : 'auto')};
`

export const StyledThChild = styled.th`
  top: 0;
  z-index: 2;
  position: sticky;
  text-align: center;
  font-weight: 600;
  font-size: 10px;
  padding: 12px 8px;
  white-space: normal;
  color: ${Colors.white};
  background: ${Colors.orient};
  border-inline: 1px solid ${Colors.white};
`

export const StyledTd = styled.td`
  text-align: center;
  padding: 10px 8px;
  background: ${({ index }) =>
    index % 2 === 0 ? Colors.concrete : Colors.white};
  /* white-space: nowrap; */
  color: ${Colors.cancelTextColor};
  border: 1px solid ${Colors.gallery};
  z-index: ${(props) => (props.isSticky ? 1 : 0)};
  left: ${(props) => (props.left ? props.left : 'auto')};
  position: ${(props) => (props.isSticky ? 'sticky' : 'static')};
`
export const StyledTdEmptyData = styled.td`
  text-align: center;
  padding: 10px 8px;
  vertical-align: middle;
`

export const StyledTr = styled.tr``

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  font-size: 18px;
  font-weight: 600;
  color: #333;
`

export const GridInnerWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
